var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7031 7.5H22.5V5.25C22.5 4.03125 21.4688 3 20.25 3H12.75L9.75 0H2.25C0.984375 0 0 1.03125 0 2.25V15.75C0 17.0156 0.984375 18 2.25 18H20.2969C21.6094 18 22.8281 17.3438 23.4844 16.2188L26.6719 10.9219C27.5625 9.42188 26.4844 7.5 24.7031 7.5ZM2.25 1.5H9.09375L12.0938 4.5H20.25C20.625 4.5 21 4.875 21 5.25V7.5H8.01562C6.70312 7.5 5.48438 8.20312 4.78125 9.32812L1.5 14.8594V2.25C1.5 1.875 1.82812 1.5 2.25 1.5ZM25.3594 10.1719L22.2188 15.4219C21.8438 16.0312 21 16.5 20.2969 16.5H2.0625L5.90625 10.125C6.28125 9.51562 7.125 9 7.875 9H24.7031C25.3125 9 25.6875 9.65625 25.3594 10.1719Z",
    fill: "#2D5049"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.c665e90c7f54c83985c1fd20df337b88.svg";
export { ForwardRef as ReactComponent };